import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceStreamService, BalanceUpdate } from '../../../services/balance-stream.service';
import { PaymentsService } from '../../../services/payment_apis/payments.service';
import { CreditsDialogComponent } from '../../../master-config-components/micro-apps/website/popups/credits-dialog/credits-dialog.component';
import { Subscription } from 'rxjs';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { PricingDetailsComponent } from '../pricing-details/pricing-details.component';

@Component({
  selector: 'app-credit-balance',
  templateUrl: './credit-balance.component.html',
  styleUrls: ['./credit-balance.component.scss']
})
export class CreditBalanceComponent implements OnInit, OnDestroy, OnChanges {
  @Input() organizationId!: string;

  balance: BalanceUpdate | null = null;
  private balanceSub!: Subscription;
  isCreditPage: boolean = false

  constructor(
    private balanceStream: BalanceStreamService,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private paymentsService: PaymentsService
  ) { }

  ngOnInit(): void {
    this.setupSubscriptions();
    if (this.organizationId && this.organizationId !== 'test-org-id') {
      this.balanceStream.connect(this.organizationId);
    }
    if(this.router.url.includes('credits')){
      this.isCreditPage = true
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationId']?.currentValue) {
      const orgId = changes['organizationId'].currentValue;
      if (orgId && orgId !== 'test-org-id') {
        this.balanceStream.connect(orgId);
      }
    }
  }

  ngOnDestroy(): void {
    this.balanceSub?.unsubscribe();
  }

  private setupSubscriptions(): void {
    this.balanceSub = this.balanceStream.balance$.subscribe((update: BalanceUpdate | null) => {
      if (update && update.organization_id === this.organizationId) {
        this.balance = update;
      }
    });
  }

  get displayCredits(): string {
    if (!this.balance) return '0';
    return Math.floor(this.balance.credits || 0).toString();
  }

  get isLowBalance(): boolean {
    return (this.balance?.credits || 0) < 100;
  }

  onCreditsClick(): void {
    // this.paymentsService.openDialog(CreditsDialogComponent, '100vh', '100vw', {});
    this.router.navigate(['/admin/credits'])
  }

  onUpgradeClick(plan: any): void {
    let pricingDetails = this.subscriptionService.openDialog(PricingDetailsComponent, '100vh', '100vw', { plan });
    pricingDetails.afterClosed().subscribe((res: any) => {
      // this.getCurrentPlanDetails();
    })
  }
}
